import Loading from "./Loading";
import React from "react";
import { useApplicationsContext } from "../../contexts/ApplicationsContext";
import { useParticipantsContext } from "../../contexts/ParticipantsContext";
import { useUserContext } from "../../contexts/UserContext";

interface UserDataLoaderProps {
  children: React.ReactNode;
}

/**
 * Komponent UserDataLoader zapewnia, że wszystkie dane użytkownika są załadowane
 * przed renderowaniem głównej aplikacji. Zapobiega miganiu starych danych
 * podczas przełączania użytkowników.
 */
export default function UserDataLoader({ children }: UserDataLoaderProps) {
  const { user, isLoading: userLoading } = useUserContext();
  const { isLoading: applicationsLoading } = useApplicationsContext();
  const { isLoading: participantsLoading } = useParticipantsContext();

  // Sprawdź czy wszystkie dane są załadowane
  const isDataLoading = userLoading || applicationsLoading || participantsLoading;

  // Sprawdź czy użytkownik jest dostępny
  const isUserReady = user && user.id;

  // Jeśli dane są ładowane lub użytkownik nie jest gotowy, pokaż loading
  if (isDataLoading || !isUserReady) {
    return <Loading />;
  }

  // Wszystkie dane są załadowane, renderuj aplikację
  return <>{children}</>;
}
